import React, { Children, Dispatch, SetStateAction, forwardRef } from 'react'

import DotsHorizontalIcon from '../../icons/DotsHorizontalIcon'

import styles from './Dropdown.module.css'

type DropdownProps = {
  isDropdownOpen: boolean
  setIsDropdownOpen: Dispatch<SetStateAction<boolean>>
  children: React.ReactNode
}

const Dropdown = forwardRef(({ children, isDropdownOpen, setIsDropdownOpen }: DropdownProps, ref: any) => {
  const childrenWithClickHandler = Children.map(children, child => {
    if (React.isValidElement<{ onClick: () => void }>(child)) {
      return React.cloneElement(child, {
        onClick: () => {
          if (child.props?.onClick) {
            child?.props?.onClick()
          }
          setIsDropdownOpen(false)
        }
      })
    }
    return child
  })

  return (
    <div className={styles.aiChatWidgetDropdownWrapper} ref={ref}>
      <button className={styles.aiChatWidgetDropdownButton} onClick={() => setIsDropdownOpen(prevState => !prevState)}>
        <DotsHorizontalIcon />
      </button>

      {isDropdownOpen && <div className={styles.aiChatWidgetDropdownItems}>{childrenWithClickHandler}</div>}
    </div>
  )
})

export default Dropdown
